var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "danger_48px",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-2{fill:#e64e48}\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "none",
    d: "M0 0H48V48H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "danger",
    transform: "translate(5.5 -29.757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4026",
    d: "M36.523 62.634L21.346 37.465a3.324 3.324 0 0 0-5.693 0L.476 62.634a3.324 3.324 0 0 0 2.847 5.04h30.353a3.324 3.324 0 0 0 2.847-5.04zm-2.05 2.166a.917.917 0 0 1-.8.465H3.323a.915.915 0 0 1-.784-1.387l15.177-25.17a.915.915 0 0 1 1.567 0l15.177 25.17a.916.916 0 0 1 .013.922z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4390",
    fill: "rgba(230,78,72,0.1)",
    d: "M34.473 64.8a.917.917 0 0 1-.8.465H3.323a.915.915 0 0 1-.784-1.387l15.177-25.17a.915.915 0 0 1 1.567 0l15.177 25.17a.916.916 0 0 1 .013.922z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4027",
    d: "M235.209 173.005c-.916 0-1.631.492-1.631 1.363 0 2.66.313 6.481.313 9.141 0 .693.6.983 1.319.983.536 0 1.3-.29 1.3-.983 0-2.66.313-6.481.313-9.141a1.436 1.436 0 0 0-1.614-1.363z",
    className: "cls-2",
    transform: "translate(-216.699 -127.237)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4028",
    d: "M234.372 353.306a1.721 1.721 0 1 0 0 3.442 1.721 1.721 0 0 0 0-3.442z",
    className: "cls-2",
    transform: "translate(-215.839 -294.508)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.5905c8ed91c6b904adb409cfaed65705.svg";
export { ForwardRef as ReactComponent };